<template>
    <div>
        <div v-if="$vuetify.breakpoint.lgAndUp">
            <div style="height: 40px; background-color:#141C2E;"></div>
            <div class="pa-3">
                <v-card v-for="items in matches" :key="items.title" flat style="background-color:rgba(20,28,46,.50); border:none;" class="mb-5 rounded-b-0">
                    <v-list class="pt-0" style="background-color:rgba(20,28,46,.50);">
                        <v-list-group
                            :value="true"
                        >
                            <template v-slot:activator>
                                <v-list-item-title style="color:white !important;"><b>{{items.title.toUpperCase()}}</b></v-list-item-title>
                            </template>
                            <v-row v-for="item in items.matches" :key="item.name">
                                <v-col cols="12" class="pb-0">
                                    <v-card flat tile style="background: #141C2E; border:none;">
                                        <v-card :style="item.status == 'WIN' ? 'background: linear-gradient(-90deg, rgba(28, 189, 147, 0.25) 0%, rgba(28, 189, 147, 0) 50%); border:none;' : 'background: linear-gradient(-90deg, rgba(235, 0, 0, 0.25) 0%, rgba(235, 0, 0, 0) 50%); border:none;'" class="pb-4 mt-2">
                                            <v-row class="d-flex justify-center py-2">
                                                <v-col cols="6">
                                                    <div class="tw-text tw-font-bold text-start ml-5 mb-3">
                                                        {{item.name}} ({{item.odds}})
                                                    </div>
                                                    <v-row>
                                                        <v-col cols="4" class="pr-0 d-flex justify-end align-center">
                                                            <div><v-img :src="item.image" width="40px" class="float-right"></v-img></div>
                                                        </v-col>
                                                        <v-col cols="8" style="align-self: center;">
                                                            <div class="text-start">{{item.team}}</div>
                                                        </v-col>
                                                    </v-row>
                                                </v-col>
                                                <v-col cols="6" class="d-flex justify-center align-center">
                                                    <div :style="item.status == 'WIN' ? 'color:#1CBD93' : 'color:#BD1C1C'">
                                                        <div class="text-h6"><b>{{item.status}}</b></div>
                                                        <div>(₱ {{item.amount}}.00)</div>
                                                    </div>
                                                </v-col>
                                            </v-row>
                                        </v-card>
                                    </v-card>
                                </v-col>
                            </v-row>
                        </v-list-group>
                    </v-list>
                </v-card>
            </div>
        </div>
        <div v-else>
            <div style="background:#141C2E; border: 1px solid black;" class="rounded-xl rounded-b-0 pb-5">
                <div class="font-weight-bold tw-text-white text-body-1 py-3">BET HISTORY</div>
                <v-card v-for="items in matches" :key="items.title" flat style="background-color:rgba(20,28,46,.50); border:none;" class="pb-5 px-10 rounded-b-0">
                    <v-list class="pt-0" style="background-color:rgba(20,28,46,.50);">
                        <v-list-group
                            :value="true"
                            style="background-color:rgba(13, 17, 27, .75) !important;"
                        >
                            <template v-slot:activator>
                                <v-list-item-title style="color:white !important; font-size: 10px !important;"><div class="font-weight-bold text-start">{{items.title.toUpperCase()}}</div></v-list-item-title>
                            </template>
                            <v-row v-for="item in items.matches" :key="item.name">
                                <v-col cols="12" class="pb-0">
                                    <v-card flat tile style="background: #141C2E; border:none;">
                                        <v-card :style="item.status == 'WIN' ? 'background: linear-gradient(-90deg, rgba(28, 189, 147, 0.25) 0%, rgba(28, 189, 147, 0) 50%); border:none;' : 'background: linear-gradient(-90deg, rgba(235, 0, 0, 0.25) 0%, rgba(235, 0, 0, 0) 50%); border:none;'" class="pb-4 mt-2">
                                            <v-row class="d-flex justify-center py-2">
                                                <v-col cols="6">
                                                    <div class="tw-text tw-font-bold text-start ml-5 mb-3" style="font-size: 12px !important;">
                                                        {{item.name}} ({{item.odds}})
                                                    </div>
                                                    <v-row>
                                                        <v-col cols="4" class="pr-0 d-flex justify-end align-center">
                                                            <div><v-img :src="item.image" width="40px" class="float-right"></v-img></div>
                                                        </v-col>
                                                        <v-col cols="8" style="align-self: center;">
                                                            <div class="text-start">{{item.team}}</div>
                                                        </v-col>
                                                    </v-row>
                                                </v-col>
                                                <v-col cols="6" class="d-flex justify-center align-center">
                                                    <div :style="item.status == 'WIN' ? 'color:#1CBD93' : 'color:#BD1C1C'">
                                                        <div><b>{{item.status}}</b></div>
                                                        <div>(₱ {{item.amount}}.00)</div>
                                                    </div>
                                                </v-col>
                                            </v-row>
                                        </v-card>
                                    </v-card>
                                </v-col>
                            </v-row>
                        </v-list-group>
                    </v-list>
                </v-card>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data () {
        return {
            matches: [
                {
                    title: "Boom Esports vs Yangon Galacticos",
                    matches: [
                        {
                            name: "Match Winner",
                            image: require('@/assets/images/Boom.svg'),
                            team: "Boom Esports",
                            status: "WIN",
                            odds: "x1.35",
                            amount: "100",
                            possible: "135"
                        },
                        {
                            name: "First 10 Kills",
                            image: require('@/assets/images/Boom.svg'),
                            team: "Boom Esports",
                            status: "LOSE",
                            odds: "x1.85",
                            amount: "120",
                            possible: "185"
                        }
                    ]
                },
                {
                    title: "Virtus.pro vs Fnatic",
                    matches: [
                        {
                            name: "Match Winner",
                            image: require('@/assets/images/Fnatic.svg'),
                            team: "Fnatic",
                            status: "LOSE",
                            odds: "x1.35",
                            amount: "100",
                            possible: "135"
                        },
                        {
                            name: "Series Handicapped Fnatic +1.5",
                            image: require('@/assets/images/Fnatic.svg'),
                            team: "Fnatic",
                            status: "LOSE",
                            odds: "x1.85",
                            amount: "120",
                            possible: "185"
                        }
                    ]
                }
            ]
        }
    },
};
</script>

<style>
.mdi-chevron-down::before {
    color: white;    
}
</style>